module.exports = __webpack_public_path__ + "img/logo.6c85b242.png";